export default "__VITE_ASSET__DC$p0GPD__"